import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import Axios from "../axios";
import { useParams, useLocation } from "react-router-dom";
import Switch from "@mui/material/Switch";
import moment from "moment";

const DailyList = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [packages, setPackages] = useState();
  const [city, setCity] = useState();
  const [allTrip, setAllTrip] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};
  const [value, setValue] = React.useState("1");

  useEffect(() => {
    if (passedValue) {
      fetchAllTrip(0, "", passedValue); // Use `passedValue` if it exists
    } else {
      fetchAllTrip(0, "", ""); // Default behavior
    }
  }, [passedValue]);

  const fetchAllTrip = (page, search, id) => {
    let data = {
      page: page,
      searchChar: search,
      userID: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-trip", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    download: false,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllTrip(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllTrip(page, searchText);
      setSearch(searchText);
    },
  };

  const columns = [
    {
      name: "Action",
      label: "Trip Image",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <img
                src={allTrip[dataIndex]?.locationImg}
                style={{ width: "60px" }}
              />
            </>
          );
        },
      },
    },
    {
      name: "tripName",
      label: "Trip Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "mail",
      label: "User Name",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <div>{allTrip[dataIndex]?.userId?.name}</div>;
        },
      },
    },
    {
      name: "role",
      label: "Created Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allTrip[dataIndex].createdAt).format("YYYY-MM-DD")}
            </div>
          );
        },
      },
    },

    {
      name: "feature trip",
      label: "Feature Trip",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Switch
                checked={allTrip[dataIndex]?.featureTrip}
                onChange={(event) =>
                  handleChangeExplore(event, allTrip[dataIndex]?._id, "feature")
                }
                inputProps={{ "aria-label": "controlled" }}
              />
            </>
          );
        },
      },
    },
    {
      name: "Explore Trip",
      label: "Explore Trip",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Switch
                checked={allTrip[dataIndex]?.explore}
                onChange={(event) =>
                  handleChangeExplore(event, allTrip[dataIndex]?._id, "explore")
                }
                inputProps={{ "aria-label": "controlled" }}
              />
            </>
          );
        },
      },
    },
  ];
  // Function for dialog open close
  const handleOpen = (userid, type) => {
    if (type === "edit") {
      setName(userid?.name);
      setEmail(userid?.mail);
      setPackages(userid?.role);
      setCity(userid?.city);
      setOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setName("");
    setEmail("");
    setPackages("");
    setCity("");
  };

  const handleChangeExplore = (event, tripId, type) => {
    handleStatus(tripId, type); // Pass the checked state and tripId
  };
  const handleStatus = (id, type) => {
    let api;
    let data = {
      id: id,
      userID: passedValue ? passedValue : "",
    };
    if (type === "explore") {
      api = "update-explore-trips";
    } else {
      api = "update-feature-trip";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  return (
    <>
      <MUIDataTable
        title={"Daily Sales"}
        data={allTrip}
        columns={columns}
        options={options}
      />

      {/* ------------------------------Create Trip Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3> Trip Details</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            className="my-2"
            placeholder="Enter your Full Name"
            name="name"
            value={name}
          />

          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            className="my-2"
            type="email"
            placeholder="abb@abbindia.com"
            name="email"
            value={email}
          />
          <TextField
            label="Package"
            variant="outlined"
            fullWidth
            className="my-2"
            name="packages"
            value={packages}
          />

          <TextField
            label="City"
            variant="outlined"
            fullWidth
            className="my-2"
            value={city}
            name="city"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default DailyList;
